import { ref } from 'config/constants'
import { showMessage } from 'data/messages/actions';

import { 
    FETCH_MEDIAGROUPS, 
    FETCH_MEDIAGROUPS_SUCCESS,
    FETCH_MEDIAGROUP, 
    FETCH_MEDIAGROUP_SUCCESS,
    UPDATE_MEDIAGROUP,
} from './types';

const Mediagroups = ref.child("mediagroups");

/* MEDIAGROUPS */
export function fetchMediagroups() {
    return dispatch => {
        dispatch({
            type: FETCH_MEDIAGROUPS,
            payload: { pending: true }
        });
        Mediagroups.on('value', snapshot => {
            dispatch({
                type: FETCH_MEDIAGROUPS_SUCCESS,
                payload: snapshot.val()
            });
        });
    };
}

/* MEDIAGROUP */

export function fetchMediagroup(key) {
    return dispatch => {
        dispatch({
            type: FETCH_MEDIAGROUP
        });

        Mediagroups.child(key).on('value', snapshot => {
            dispatch({
                type: FETCH_MEDIAGROUP_SUCCESS,
                payload: snapshot.val()
            });
        });
    };
}

export function createMediagroup(mediagroup, handleClick) {
    return dispatch => Mediagroups.push(mediagroup).then( (snapshot) => { 
        handleClick(snapshot.key)
    })
}

export function updateMediagroup(key, mediagroup) {
    return dispatch => { 

        dispatch({type: UPDATE_MEDIAGROUP, payload: { pending : true } })

        return Mediagroups.child(key).set(mediagroup).
                       then( () => {
                           dispatch(showMessage(`${mediagroup.name} har sparats.`) )
                       }).
                       catch( (error) => {
                           dispatch(showMessage(error.message) )
                       }).
                       then( () => {
                           dispatch({type: UPDATE_MEDIAGROUP, payload: { pending : false } })
                       })
    }
}

export function deleteMediagroup(key) {
    return dispatch => { 

        Mediagroups.child(key).remove().
                then( 
                    dispatch(showMessage(`Mediagroupen har raderats.`) )
                ).
                catch( (error) => {
                    dispatch(showMessage(error.message) )
                })
    }
}




// WEBPACK FOOTER //
// ./src/data/mediagroups/actions.js